import React, { useState, useRef, useEffect } from 'react';
import html2pdf from 'html2pdf.js';

import axios from 'axios';
import { useSelector } from 'react-redux';
import { encryptData } from '../../utils/cryptoUtils';
import config from '../../config';

/* =========================================================
   LANGUAGE / TRANSLATION CONFIG
   Add a new language by adding a new key here (e.g. 'gu', 'bn')
   and it will automatically show up in the dropdown.
========================================================= */
const LANGUAGES = [
  { code: 'hi', label: 'हिंदी (Hindi)' },
  { code: 'en', label: 'English' },
  { code: 'mr', label: 'मराठी (Marathi)' },
  { code: 'ta', label: 'தமிழ் (Tamil)' },
];

const TRANSLATIONS = {
  hi: {
    pageTitle: 'देय अनुस्मारक सूचना',
    tabs: { Applicant: 'आवेदक', 'Co-applicant': 'सह-आवेदक', Guarantor: 'गारंटर' },
    previewBtn: 'पूर्वावलोकन',
    downloadBtn: 'पीडीएफ डाउनलोड करें',
    to: 'सेवा में,',
    address: 'पता -',
    mobile: 'मोबाइल नंबर -',
    vehicleNo: 'वाहन नंबर -',
    dateLabel: 'दिनांक:',
    reference: 'संदर्भ :',
    noRecordFound: (type) => `इस समझौते के लिए कोई ${type} रिकॉर्ड नहीं मिला।`,
    coGuarantorHeading: (type) => `${type} को देय अनुस्मारक पत्र`,
    applicantIntro: (amt) =>
      `आपका ऋण खाता में रु. ${amt} की देय राशि बकाया है।`,
    applicantIntro2:
      'कृपया डिमांड ड्राफ्ट /RTGS/ UPI/ NEFT/ /चेक द्वारा भुगतान कर सकते हैं (बैंक: ICICI Bank, शाखा, दिल्ली, खाता संख्या: 182005001431). कृपया जमा की गई राशि को वाहन नंबर और जमा की तारीख का उल्लेख करते हुए मोबाइल नंबर 8882247409 पर सूचित करें। समझौते के नियमों और शर्तों के अनुसार संग्रह शुल्क और देर से भुगतान के लिए अतिरिक्त शुल्क और अन्य शुल्क अलग से लिया जाएगा।',
    coApplicantIntro: (amt) =>
      `आपका आवेदक के ऋण खाते में रु. ${amt} की देय राशि बकाया है।`,
    coApplicantPara2:
      'हमने आवेदक को उसकी बकाया राशि के साथ-साथ संग्रह शुल्क और देर से भुगतान के लिए अतिरिक्त किराया शुल्क और समझौते के नियमों और शर्तों के अनुसार अन्य शुल्कों के बारे में सूचित कर दिया है।',
    coApplicantPara3:
      'कृपया आवेदक को उपरोक्त शेष राशि तीन (3) दिनों के भीतर जमा करें अथवा किसी भी कार्य दिवस पर सुबह 09:30 बजे से शाम 6:30 बजे तक हमारे कार्यालय से संपर्क करें।',
    coApplicantPara4:
      'हम आपको यह भी बताना चाहते हैं कि आपका आवेदक यदि EMI का भुगतान नहीं करता है तो गारंटर एवं सह-आवेदक के साथ आपके ऋण खाते की लंबित राशि ब्यूरो में रिपोर्ट की जा सकती है।',
    table: {
      agreementNo: 'Agreement No',
      regNo: 'Registration Number',
      model: 'Model',
      agreementDate: 'Agreement Date',
      emiDueCount: 'Total Number of EMI Dues',
      instalmentAmount: 'Instalment Amount',
      lastReceiptDate: 'Last Receipt Date',
      totalDues: 'Total Dues',
    },
    depositPara:
      'कृपया उपरोक्त शेष राशि तीन (3) दिनों के भीतर जमा करें या किसी भी कार्य दिवस पर सुबह 09:30 बजे से शाम 6:30 बजे तक हमारे कार्यालय से संपर्क करें और हमें सलाह दें कि हम आपका भुगतान कब प्राप्त करने की उम्मीद कर सकते हैं या क्या आप अन्य वित्तीय भुगतान करना चाहते हैं तो कर सकते हैं।',
    bureauPara:
      'हम आपको यह भी बताना चाहते हैं कि यदि आपकी EMI या EMI का भुगतान न करने के कारण उत्पन्न कोई अन्य शुल्क महीने के अंत तक भुगतान नहीं किया गया है तो हम गारंटर और सह-आवेदक के साथ आपके ऋण खाते की लंबित राशि की ब्यूरो में RBI दिशानिर्देशों के अनुसार रिपोर्ट करेंगे।',
    ignoreNote: 'यदि भुगतान किया गया है तो कृपया इसे अनदेखा करें।',
    forCompany: 'For cKers Finance Private Limited',
    signatory: 'Manager/Authorized Signatory',
    companyName: 'cKers Finance Private Limited',
    companyAddress: 'Building No-24-30,First Floor, Okhla Industrial Estate,Phase-III, New Delhi 110020, INDIA',
    companyContact: 'Phone +91-11-41070629 contact@ckersfinance.in',
  },

  en: {
    pageTitle: 'Due Reminder Notice',
    tabs: { Applicant: 'Applicant', 'Co-applicant': 'Co-applicant', Guarantor: 'Guarantor' },
    previewBtn: 'PREVIEW',
    downloadBtn: 'DOWNLOAD PDF',
    to: 'To,',
    address: 'Address -',
    mobile: 'Mobile No -',
    vehicleNo: 'Vehicle No -',
    dateLabel: 'Date:',
    reference: 'Reference :',
    noRecordFound: (type) => `No ${type} record found for this agreement.`,
    coGuarantorHeading: (type) => `Due Reminder Letter To ${type}`,
    applicantIntro: (amt) =>
      `An amount of Rs. ${amt} is overdue on your loan account.`,
    applicantIntro2:
      'You may pay via Demand Draft / RTGS / UPI / NEFT / Cheque (Bank: ICICI Bank, Delhi Branch, Account No: 182005001431). Please inform us of the deposited amount along with the vehicle number and date of deposit on mobile number 8882247409. Collection charges, late payment charges and other charges will be levied separately as per the terms and conditions of the agreement.',
    coApplicantIntro: (amt) =>
      `An amount of Rs. ${amt} is overdue on the applicant's loan account.`,
    coApplicantPara2:
      'We have already informed the applicant about the outstanding amount, along with collection charges, additional late payment charges, and other charges as per the terms and conditions of the agreement.',
    coApplicantPara3:
      'Please ensure the applicant deposits the above outstanding amount within three (3) days, or contact our office on any working day between 09:30 AM and 06:30 PM.',
    coApplicantPara4:
      'We would also like to inform you that if the applicant fails to pay the EMI, the outstanding amount on the loan account may be reported to the bureau along with the guarantor and co-applicant.',
    table: {
      agreementNo: 'Agreement No',
      regNo: 'Registration Number',
      model: 'Model',
      agreementDate: 'Agreement Date',
      emiDueCount: 'Total Number of EMI Dues',
      instalmentAmount: 'Instalment Amount',
      lastReceiptDate: 'Last Receipt Date',
      totalDues: 'Total Dues',
    },
    depositPara:
      'Please deposit the above outstanding amount within three (3) days, or contact our office on any working day between 09:30 AM and 06:30 PM, and advise us when we can expect to receive your payment or if you wish to make an alternate financial arrangement.',
    bureauPara:
      'We would also like to inform you that if your EMI or any other charges arising due to non-payment of EMI are not paid by the end of the month, we will report the outstanding amount on your loan account to the bureau, along with the guarantor and co-applicant, as per RBI guidelines.',
    ignoreNote: 'If the payment has already been made, please ignore this notice.',
    forCompany: 'For cKers Finance Private Limited',
    signatory: 'Manager/Authorized Signatory',
    companyName: 'cKers Finance Private Limited',
    companyAddress: 'Building No-24-30, First Floor, Okhla Industrial Estate, Phase-III, New Delhi 110020, INDIA',
    companyContact: 'Phone +91-11-41070629 contact@ckersfinance.in',
  },

  mr: {
    pageTitle: 'देय स्मरणपत्र सूचना',
    tabs: { Applicant: 'अर्जदार', 'Co-applicant': 'सह-अर्जदार', Guarantor: 'हमीदार' },
    previewBtn: 'पूर्वावलोकन',
    downloadBtn: 'पीडीएफ डाउनलोड करा',
    to: 'प्रति,',
    address: 'पत्ता -',
    mobile: 'मोबाइल क्रमांक -',
    vehicleNo: 'वाहन क्रमांक -',
    dateLabel: 'दिनांक:',
    reference: 'संदर्भ :',
    noRecordFound: (type) => `या करारासाठी कोणतीही ${type} नोंद आढळली नाही.`,
    coGuarantorHeading: (type) => `${type} यांना देय स्मरणपत्र पत्र`,
    applicantIntro: (amt) =>
      `तुमच्या कर्ज खात्यात रु. ${amt} इतकी रक्कम थकीत आहे.`,
    applicantIntro2:
      'कृपया डिमांड ड्राफ्ट / RTGS / UPI / NEFT / चेकद्वारे भरणा करू शकता (बँक: ICICI Bank, शाखा, दिल्ली, खाते क्रमांक: 182005001431). जमा केलेल्या रकमेची माहिती वाहन क्रमांक आणि जमा तारखेसह मोबाइल क्रमांक 8882247409 वर कळवावी. कराराच्या अटी व शर्तींनुसार संकलन शुल्क आणि विलंब भरणा शुल्क तसेच इतर शुल्क स्वतंत्रपणे आकारले जाईल.',
    coApplicantIntro: (amt) =>
      `अर्जदाराच्या कर्ज खात्यात रु. ${amt} इतकी रक्कम थकीत आहे.`,
    coApplicantPara2:
      'आम्ही अर्जदाराला थकीत रकमेसह, संकलन शुल्क, विलंब भरणा शुल्क आणि कराराच्या अटी व शर्तींनुसार इतर शुल्कांबाबत आधीच कळवले आहे.',
    coApplicantPara3:
      'कृपया अर्जदाराने वरील थकीत रक्कम तीन (3) दिवसांच्या आत जमा करावी अथवा कोणत्याही कामकाजाच्या दिवशी सकाळी 09:30 ते सायंकाळी 06:30 या वेळेत आमच्या कार्यालयाशी संपर्क साधावा.',
    coApplicantPara4:
      'आम्ही आपणास हे देखील कळवू इच्छितो की जर अर्जदाराने EMI चा भरणा केला नाही, तर हमीदार व सह-अर्जदारासह आपल्या कर्ज खात्यातील थकीत रक्कम ब्युरोकडे नोंदवली जाऊ शकते.',
    table: {
      agreementNo: 'Agreement No',
      regNo: 'Registration Number',
      model: 'Model',
      agreementDate: 'Agreement Date',
      emiDueCount: 'Total Number of EMI Dues',
      instalmentAmount: 'Instalment Amount',
      lastReceiptDate: 'Last Receipt Date',
      totalDues: 'Total Dues',
    },
    depositPara:
      'कृपया वरील शिल्लक रक्कम तीन (3) दिवसांच्या आत जमा करा किंवा कोणत्याही कामकाजाच्या दिवशी सकाळी 09:30 ते सायंकाळी 06:30 या वेळेत आमच्या कार्यालयाशी संपर्क साधून आम्हाला कळवा की आम्ही तुमचा भरणा कधी मिळण्याची अपेक्षा करू शकतो किंवा तुम्हाला इतर आर्थिक व्यवस्था करायची असल्यास कळवा.',
    bureauPara:
      'आम्ही तुम्हाला हे देखील कळवू इच्छितो की जर तुमचा EMI किंवा EMI न भरल्यामुळे उद्भवणारे इतर कोणतेही शुल्क महिन्याच्या अखेरीपर्यंत भरले गेले नाही, तर आम्ही RBI मार्गदर्शक तत्त्वांनुसार हमीदार व सह-अर्जदारासह तुमच्या कर्ज खात्यातील थकीत रक्कम ब्युरोकडे नोंदवू.',
    ignoreNote: 'भरणा आधीच केला असल्यास, कृपया याकडे दुर्लक्ष करा.',
    forCompany: 'For cKers Finance Private Limited',
    signatory: 'Manager/Authorized Signatory',
    companyName: 'cKers Finance Private Limited',
    companyAddress: 'Building No-24-30, First Floor, Okhla Industrial Estate, Phase-III, New Delhi 110020, INDIA',
    companyContact: 'Phone +91-11-41070629 contact@ckersfinance.in',
  },

  ta: {
    pageTitle: 'நிலுவைத் தொகை நினைவூட்டல் அறிவிப்பு',
    tabs: { Applicant: 'விண்ணப்பதாரர்', 'Co-applicant': 'இணை-விண்ணப்பதாரர்', Guarantor: 'உத்தரவாதி' },
    previewBtn: 'முன்னோட்டம்',
    downloadBtn: 'பிடிஎஃப் பதிவிறக்கவும்',
    to: 'பெறுநர்,',
    address: 'முகவரி -',
    mobile: 'மொபைல் எண் -',
    vehicleNo: 'வாகன எண் -',
    dateLabel: 'தேதி:',
    reference: 'குறிப்பு :',
    noRecordFound: (type) => `இந்த ஒப்பந்தத்திற்கு ${type} பதிவு எதுவும் இல்லை.`,
    coGuarantorHeading: (type) => `${type} க்கு நிலுவைத் தொகை நினைவூட்டல் கடிதம்`,
    applicantIntro: (amt) =>
      `உங்கள் கடன் கணக்கில் ரூ. ${amt} நிலுவையில் உள்ளது.`,
    applicantIntro2:
      'தயவுசெய்து டிமாண்ட் டிராஃப்ட் / RTGS / UPI / NEFT / காசோலை மூலம் செலுத்தலாம் (வங்கி: ICICI Bank, டெல்லி கிளை, கணக்கு எண்: 182005001431). வரவு வைக்கப்பட்ட தொகையை வாகன எண் மற்றும் வரவு வைக்கப்பட்ட தேதியுடன் மொபைல் எண் 8882247409-க்கு தெரிவிக்கவும். ஒப்பந்தத்தின் விதிமுறைகள் மற்றும் நிபந்தனைகளின்படி வசூல் கட்டணம் மற்றும் தாமத கட்டணம் மற்றும் பிற கட்டணங்கள் தனியாக வசூலிக்கப்படும்.',
    coApplicantIntro: (amt) =>
      `விண்ணப்பதாரரின் கடன் கணக்கில் ரூ. ${amt} நிலுவையில் உள்ளது.`,
    coApplicantPara2:
      'நிலுவைத் தொகை, வசூல் கட்டணம், தாமத கட்டணம் மற்றும் ஒப்பந்த விதிமுறைகளின்படியான பிற கட்டணங்கள் குறித்து விண்ணப்பதாரருக்கு ஏற்கனவே தெரிவிக்கப்பட்டுள்ளது.',
    coApplicantPara3:
      'மேற்கண்ட நிலுவைத் தொகையை மூன்று (3) நாட்களுக்குள் விண்ணப்பதாரர் செலுத்துமாறு உறுதி செய்யவும், அல்லது எந்த வேலை நாளிலும் காலை 09:30 முதல் மாலை 06:30 வரை எங்கள் அலுவலகத்தை தொடர்பு கொள்ளவும்.',
    coApplicantPara4:
      'விண்ணப்பதாரர் EMI செலுத்தத் தவறினால், உத்தரவாதி மற்றும் இணை-விண்ணப்பதாரருடன் சேர்த்து உங்கள் கடன் கணக்கின் நிலுவைத் தொகை பியூரோவிற்கு தெரிவிக்கப்படலாம் என்பதையும் தெரிவித்துக்கொள்கிறோம்.',
    table: {
      agreementNo: 'Agreement No',
      regNo: 'Registration Number',
      model: 'Model',
      agreementDate: 'Agreement Date',
      emiDueCount: 'Total Number of EMI Dues',
      instalmentAmount: 'Instalment Amount',
      lastReceiptDate: 'Last Receipt Date',
      totalDues: 'Total Dues',
    },
    depositPara:
      'மேற்கண்ட நிலுவைத் தொகையை மூன்று (3) நாட்களுக்குள் செலுத்தவும் அல்லது எந்த வேலை நாளிலும் காலை 09:30 முதல் மாலை 06:30 வரை எங்கள் அலுவலகத்தை தொடர்பு கொண்டு, உங்கள் கட்டணத்தை எப்போது பெறலாம் என்றோ அல்லது வேறு நிதி ஏற்பாடு செய்ய விரும்புகிறீர்களா என்றோ எங்களுக்குத் தெரிவிக்கவும்.',
    bureauPara:
      'உங்கள் EMI அல்லது EMI செலுத்தாததால் ஏற்படும் பிற கட்டணங்கள் மாத இறுதிக்குள் செலுத்தப்படவில்லை எனில், RBI வழிகாட்டுதல்களின்படி உத்தரவாதி மற்றும் இணை-விண்ணப்பதாரருடன் சேர்த்து உங்கள் கடன் கணக்கின் நிலுவைத் தொகையை பியூரோவிற்கு தெரிவிப்போம் என்பதையும் தெரிவித்துக்கொள்கிறோம்.',
    ignoreNote: 'கட்டணம் ஏற்கனவே செலுத்தப்பட்டிருந்தால், இந்த அறிவிப்பைப் புறக்கணிக்கவும்.',
    forCompany: 'For cKers Finance Private Limited',
    signatory: 'Manager/Authorized Signatory',
    companyName: 'cKers Finance Private Limited',
    companyAddress: 'Building No-24-30, First Floor, Okhla Industrial Estate, Phase-III, New Delhi 110020, INDIA',
    companyContact: 'Phone +91-11-41070629 contact@ckersfinance.in',
  },
};

const LoanOverdue = ({ AgreementNo }) => {
  const [activeTab, setActiveTab] = useState('Applicant');
  const [lang, setLang] = useState('hi'); // default Hindi
  const letterRef = useRef();

  const t = TRANSLATIONS[lang] || TRANSLATIONS.hi;

  const getPdfOptions = () => ({
    margin: [0.2, 0.2, 0.2, 0.2],
    filename: `Due_Reminder_${activeTab}_${lang}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, letterRendering: true },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
  });

  const handleDownloadPdf = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).save();
    logDownload(activeTab);
  };

  const handlePreview = () => {
    html2pdf()
      .set(getPdfOptions())
      .from(letterRef.current)
      .outputPdf('bloburl')
      .then((url) => {
        window.open(url, '_blank');
      });
  };

  const tabs = ['Applicant', 'Co-applicant', 'Guarantor'];

  // ✅ AgreementNo direct prop se aa raha hai, atob/useParams ki zaroorat nahi
  const [dueData, setDueData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState('');

  useEffect(() => {
    if (AgreementNo) {
      getDueLetterData();
    } else {
      setLoading(false);
      setFetchError('Agreement No not found.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AgreementNo]);

  const getDueLetterData = async () => {
    try {
      setLoading(true);
      setFetchError('');

      const formData = new FormData();
      formData.append('agreement_no', AgreementNo);

      const res = await axios.post(`${config.API_BASE_URL}get_due_letter_data`, formData);

      if (res.data.status) {
        setDueData(res.data);
      } else {
        setFetchError(res.data.message || 'No data found.');
      }
    } catch (err) {
      console.log(err);
      setFetchError('Something went wrong while fetching due letter data.');
    } finally {
      setLoading(false);
    }
  };

  const userInfo = useSelector((state) => state.userInfo);
  const userId = userInfo?.id;

  const logDownload = async (letterType) => {
    try {
      const payload = {
        agreement_no: AgreementNo,
        user_id: userId,
        letter_type: letterType, // "Applicant" / "Co-applicant" / "Guarantor"
        language: lang,
      };

      await fetch(`${config.API_BASE_URL}logOverdueLetterDownload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload),
      });
    } catch (err) {
      console.log('Download log failed', err);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: '#ffffff',
        }}
      >
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div
          style={{
            width: '48px',
            height: '48px',
            border: '5px solid #e0e0e0',
            borderTop: '5px solid #00b8d4',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
      </div>
    );
  }

  if (fetchError) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#d32f2f' }}>
        {fetchError}
      </div>
    );
  }

  const current =
    activeTab === 'Applicant'
      ? dueData?.applicant
      : activeTab === 'Co-applicant'
      ? dueData?.co_applicants?.[0]
      : dueData?.guarantors?.[0];

  const noRecordFound = activeTab !== 'Applicant' && !current;

  const tableRow = (label, value, uppercase = false) => (
    <tr>
      <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold' }}>{label}</td>
      <td
        style={{
          border: '1px solid #000',
          padding: '5px 8px',
          textAlign: 'right',
          textTransform: uppercase ? 'uppercase' : 'none',
        }}
      >
        {value ?? '-'}
      </td>
    </tr>
  );

  const coGuarantorTypeLabel = activeTab === 'Co-applicant' ? t.tabs['Co-applicant'] : t.tabs.Guarantor;

  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>
      {/* Header section */}
      <div style={{ padding: '20px 40px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
            marginBottom: '20px',
          }}
        >
          <h2 style={{ fontSize: '22px', fontWeight: 'bold', margin: 0 }}>{t.pageTitle}</h2>

          {/* Language Selector */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label htmlFor="letterLanguage" style={{ fontSize: '13px', fontWeight: 'bold', color: '#333' }}>
              Language:
            </label>
            <select
              id="letterLanguage"
              value={lang}
              onChange={(e) => setLang(e.target.value)}
              style={{
                padding: '8px 14px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#333',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }}
            >
              {LANGUAGES.map((l) => (
                <option key={l.code} value={l.code}>
                  {l.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div
          style={{
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            display: 'flex',
            padding: '0 20px',
            borderBottom: '1px solid #eee',
          }}
        >
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                padding: '15px 25px',
                cursor: 'pointer',
                color: activeTab === tab ? '#00b8d4' : '#637381',
                borderBottom: activeTab === tab ? '3px solid #00b8d4' : '3px solid transparent',
                fontWeight: activeTab === tab ? 'bold' : '500',
                fontSize: '15px',
                transition: 'all 0.2s',
              }}
            >
              {t.tabs[tab]}
            </button>
          ))}
        </div>

        <div
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', marginTop: '20px', marginBottom: '20px' }}
        >
          <button
            onClick={handlePreview}
            style={{
              backgroundColor: '#00b8d4',
              color: '#fff',
              border: 'none',
              padding: '10px 24px',
              borderRadius: '6px',
              fontSize: '10px',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            {t.previewBtn}
          </button>
          <button
            onClick={handleDownloadPdf}
            style={{
              backgroundColor: '#ffb300',
              color: '#fff',
              border: 'none',
              padding: '10px 24px',
              borderRadius: '6px',
              fontSize: '10px',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            {t.downloadBtn}
          </button>
        </div>
      </div>

      {/* Letter Content Container */}
      <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '60px' }}>
        <div
          ref={letterRef}
          style={{
            width: '740px',
            border: '1px solid #000',
            padding: '30px 40px',
            backgroundColor: '#fff',
            boxSizing: 'border-box',
            color: '#000',
            fontSize: '12px',
            lineHeight: '1.5',
          }}
        >
          {/* Logo & Company Header */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '8px' }}>
              <img
                src="/assets/ckern-logo.png"
                alt="cKers Finance"
                style={{ height: '55px' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '4px', color: '#003366' }}>
              {t.companyName}
            </div>
            <div style={{ fontSize: '11px', fontWeight: '500' }}>{t.companyAddress}</div>
            <div style={{ fontSize: '11px', fontWeight: '500' }}>{t.companyContact}</div>
          </div>

          {activeTab === 'Applicant' ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div>
                  <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{t.to}</div>
                  <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>{current?.name}</div>
                  <div>{t.address} {current?.full_address}</div>
                  <div>{t.mobile} {current?.mobile}</div>
                  <div style={{ marginTop: '12px' }}>{t.vehicleNo} {current?.vehicle_no}</div>
                </div>
                <div style={{ whiteSpace: 'nowrap' }}>
                  <div style={{ fontWeight: 'bold' }}>{t.dateLabel} {current?.date}</div>
                </div>
              </div>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>
                {t.applicantIntro(current?.TotalLoanOverdueAmount)}
                <br />
                {t.applicantIntro2}
              </div>

              <table
                style={{
                  borderCollapse: 'collapse',
                  width: '65%',
                  marginBottom: '15px',
                  fontSize: '11px',
                  border: '1px solid #000',
                }}
              >
                <tbody>
                  {tableRow(t.table.agreementNo, current?.agreement_no)}
                  {tableRow(t.table.regNo, current?.vehicle_no)}
                  {tableRow(t.table.model, current?.model, true)}
                  {tableRow(t.table.agreementDate, current?.agreement_date)}
                  {tableRow(t.table.emiDueCount, current?.emi_due_count)}
                  {tableRow(t.table.instalmentAmount, `₹ ${current?.emi_amount}`)}
                  {tableRow(t.table.lastReceiptDate, current?.last_receipt_date)}
                  {tableRow(t.table.totalDues, `₹ ${current?.TotalLoanOverdueAmount}`)}
                </tbody>
              </table>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>{t.depositPara}</div>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>{t.bureauPara}</div>

              <div style={{ marginBottom: '30px' }}>{t.ignoreNote}</div>

              <div>
                <div style={{ fontWeight: 'bold', marginBottom: '40px' }}>{t.forCompany}</div>
                <div style={{ fontWeight: 'bold' }}>{t.signatory}</div>
              </div>
            </>
          ) : noRecordFound ? (
            <div style={{ padding: '60px 0', textAlign: 'center', color: '#666' }}>
              {t.noRecordFound(coGuarantorTypeLabel)}
            </div>
          ) : (
            <>
              <div
                style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  fontSize: '13px',
                  textDecoration: 'underline',
                }}
              >
                {t.coGuarantorHeading(coGuarantorTypeLabel)}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div>
                  <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{t.to}</div>
                  <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>{current?.name}</div>
                  <div>{t.address} {current?.full_address}</div>
                  <div>{t.mobile} {current?.mobile}</div>
                  <div style={{ marginTop: '12px' }}>{t.vehicleNo} {current?.vehicle_no}</div>
                </div>
                <div style={{ whiteSpace: 'nowrap' }}>
                  <div style={{ fontWeight: 'bold' }}>{t.dateLabel} {current?.date}</div>
                </div>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <div>{t.reference} {dueData?.applicant?.name}</div>
              </div>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>
                {t.coApplicantIntro(current?.TotalLoanOverdueAmount)}
              </div>

              <table
                style={{
                  borderCollapse: 'collapse',
                  width: '65%',
                  marginBottom: '15px',
                  fontSize: '11px',
                  border: '1px solid #000',
                }}
              >
                <tbody>
                  {tableRow(t.table.agreementNo, current?.agreement_no)}
                  {tableRow(t.table.regNo, current?.vehicle_no)}
                  {tableRow(t.table.model, current?.model, true)}
                  {tableRow(t.table.agreementDate, current?.agreement_date)}
                  {tableRow(t.table.emiDueCount, current?.emi_due_count)}
                  {tableRow(t.table.instalmentAmount, `₹ ${current?.emi_amount}`)}
                  {tableRow(t.table.lastReceiptDate, current?.last_receipt_date)}
                  {tableRow(t.table.totalDues, `₹ ${current?.TotalLoanOverdueAmount}`)}
                </tbody>
              </table>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>{t.coApplicantPara2}</div>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>{t.coApplicantPara3}</div>

              <div style={{ marginBottom: '15px', textAlign: 'justify' }}>{t.coApplicantPara4}</div>

              <div style={{ marginBottom: '30px' }}>{t.ignoreNote}</div>

              <div>
                <div style={{ fontWeight: 'bold', marginBottom: '40px' }}>{t.forCompany}</div>
                <div style={{ fontWeight: 'bold' }}>{t.signatory}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoanOverdue;